import { Navigate, Route, Routes } from "react-router-dom"
import { AddCompany } from "../components/companies/AddCompany"
import { GetUser } from "../components/miProfile/GetUser"
import { AddStartup } from "../components/startup"
import { GetStartupData } from "../components/opportunities/GetStartupData"
import { GetStartupsList } from "../components/startup/valoration/GetStartupsList"
import { AddVehicle } from "../components/vehicles"
import { Events, Opportunities, Partners, IndividualsListPage, Startup, Companies, AddPartner, PositionsClub, PositionsLP } from "../views"
import { Vehicle } from "../views/Vehicle"
import { AddEvent } from "../components/events/AddEvent"
import { ConfirmEvents } from "../components/events/ConfirmEvents"
import { Funds } from "../views/Funds"
import { ViewRegistered } from "../components/events/eventRegistered/ViewRegistered"
import { AddEventRegistered } from "../components/events/eventRegistered/AddEventRegistered"
import { GetReservation } from "../components/reservation/GetReservation"
import { ViewOpportunity } from "../components/opportunities/ViewOpportunity"
import { PositionView } from "../components/positions/PositionView"
import { GetDataAddForm } from "../components/reservation/GetDataAddForm"
import { AddFunds } from "../components/positions/funds/AddFunds"
import { ViewFunds } from "../components/positions/funds/ViewFunds"
import { AddContributions } from "../components/positions/funds/AddContributions"
import { AddInvestment } from "../components/positions/AddInvestment"
import { AddDistribution } from "../components/positions/funds/AddDistribution"
import { GetStartupDataRound } from "../components/positions/GetStartupDataRound"
import { ViewIndividualPosition } from "../components/positions/ViewIndividualPosition"
import { LandingEdit } from "../views/LandingEdit"
import { NetworkingList } from "../views/NetworkingList"
// import IframeExternal from "../components/iFrame/IFrame"

export const FaradayRoutes = () => {
  return (
    <Routes>
        <Route path='/' element={<IndividualsListPage/>}/>
        <Route path='/events' element={<Events/>}/>
        <Route path='/opportunities' element={<Opportunities/>}/>
        <Route path='/addOpportunities' element={<GetStartupData/>}/>
        <Route path='/partners' element={<Partners/>}/>
        <Route path='/positions' element={<PositionsClub/>}/>
        <Route path='/myprofile' element={<GetUser/>}/>
        <Route path='/addpartner' element={<AddPartner/>}/>
        <Route path='/startup' element={<Startup/>}/>
        <Route path='/companies' element={<Companies/>}/>
        <Route path='/addevent' element={<AddEvent/>}/>
        <Route path='/addCompanie' element={<AddCompany/>}/>
        <Route path='/addStartup' element={<AddStartup/>}/>
        <Route path='/vehicle' element={<Vehicle/>}/>
        <Route path='/addVehicle' element={<AddVehicle/>}/>
        <Route path='/addStartupValoration' element={<GetStartupsList/>}/>
        <Route path='/confirmEvent' element={<ConfirmEvents/>}/>
        <Route path='/funds' element={<Funds/>}/>
        <Route path='/viewRegistered' element={<ViewRegistered/>}/>
        <Route path='/addRegisteredEvent' element={<AddEventRegistered/>}/>
        <Route path='/reservation' element={<GetReservation/>}/>
        <Route path='/opportunityViews' element={<ViewOpportunity/>}/>
        <Route path='/positionsViews' element={<PositionView/>}/>
        <Route path='/addReservation' element={<GetDataAddForm/>}/>
        <Route path='/addFunds' element={<AddFunds/>}/>
        <Route path='/viewFunds' element={<ViewFunds/>}/>
        <Route path='/addContributions' element={<AddContributions/>}/>
        <Route path='/addPosition' element={<AddInvestment/>}/>
        <Route path='/addFundDistribution' element={<AddDistribution/>}/>
        <Route path='/positionsLP' element={<PositionsLP/>}/>
        <Route path='/createRound' element={<GetStartupDataRound/>}/>
        <Route path='/viewUserPositions' element={<ViewIndividualPosition/>}/>
        <Route path='/landingEdit' element={<LandingEdit/>}/>
        <Route path='/networking' element={<NetworkingList/>}/>
        {/* <Route path='/externalPage' element={<IframeExternal/>}/> */}

        <Route path='/*' element={<Navigate to='/'/>}/>
    </Routes>
  )
}
